import { BookOpenIcon, ClipboardCheckIcon, ClipboardListIcon, FlaskConicalIcon, GlobeIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '30 Schede di Attività in Classe sulle Energie Rinnovabili',
    description: 'Schede pronte organizzate per tema, con obiettivo, durata, materiali e domande guida.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Banca di Quiz e Verifiche Rapide con Soluzioni',
    description: 'Quiz e verifiche per ogni unità, con soluzioni complete pronte da usare.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: '10 Esperimenti di Laboratorio Low-Cost sulle Energie Rinnovabili',
    description: 'Esperimenti semplici e sicuri con materiali comuni, procedura e spiegazione.',
    icon: FlaskConicalIcon,
  },
  {
    number: '4',
    title: 'Glossario Illustrato delle Energie Rinnovabili: 150 Concetti Spiegati per la Classe',
    description: 'I termini chiave spiegati in modo chiaro e visivo per gli studenti.',
    icon: BookOpenIcon,
  },
  {
    number: '5',
    title: 'Progetti Interdisciplinari ed Educazione Civica sulla Sostenibilità Energetica',
    description: "Progetti che collegano le rinnovabili a più materie e all'educazione civica.",
    icon: GlobeIcon,
  },
];
